import { metrics } from '@atlassian/browser-metrics';
import type { Metric } from '@atlassian/browser-metrics/types';

export const viewDeadAirMetrics = {
	createViewDeadAirMetrics: (): Metric => {
		return metrics.interaction({
			key: 'ai-mate.view-dead-air',
		});
	},
};
